import * as Mutations from './mutations';
import { SMSTrackingService } from '../../../common/services/settings/sms-tracking.service';
import { PaginationParams } from '../../../common/utils/pagination-params';
export const SMSTrackingModule = {
    state: {
        SMSList: [],
        resendSMS: null
    },
    mutations: {
        [Mutations.SET_SMS] (state, SMSList) {
            state.SMSList = SMSList;
        },
        [Mutations.RESEND_SMS_MODAL_ID] (state, resendSMS) {
            state.resendSMS = resendSMS;
        },
    },
    actions: {
        async getSMSList(context) {
            const { data: { content, pageable, totalPages, totalElements, numberOfElements } } =
                await SMSTrackingService.getSMSList(context.getters.schoolId,
                    PaginationParams.createParams({
                        size: context.getters.pageSize,
                        page: context.getters.pageNumber,
                        sort: context.getters.sortBy,
                        direction: context.getters.direction,
                        query: context.getters.searchQuery,
                        filters: {
                            ...context.getters.filters
                        }
                    }));
                    context.commit(Mutations.SET_SMS, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getSMSList');
                }
            });
            context.dispatch('resetSelectedItems');
        },
        async prepareSMS(context,payload) {
            const { SMSId, recipientsModal, viewEmailModal } = payload;
            const SMS = await SMSTrackingService.getSMSById(context.getters.schoolId, SMSId);
            context.commit(Mutations.RESEND_SMS_MODAL_ID, SMS.data);
            context.dispatch('openModal', {
                modalName: recipientsModal ? 'SMSRecipientsModal' : (
                    viewEmailModal ? 'SMSTrackingUneditableModal' : 'SMSTrackingBulkModal'
                    ),
                options: {
                    width: '480px',
                },
            });
        },
        resetResendSMS(context) {
            context.commit(Mutations.RESEND_SMS_MODAL_ID, null);
        },
    },
    getters: {
        SMSList: state => state.SMSList,
        resendSMS: state => state.resendSMS,
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/sms-tracking/sms-tracking.module.js